import * as ACTION_TYPES from './types';

export function toggleStatusUploadingFile() {
  return {
    type: ACTION_TYPES.MESSAGE_UPLOADING_FILE,
  };
}

export function bubblesAdd(payload) {
  return {
    type: ACTION_TYPES.BUBBLE_CHAT_ADD,
    payload,
  };
}

export function bubblesRemove(id) {
  return {
    type: ACTION_TYPES.BUBBLE_CHAT_REMOVE,
    payload: { id },
  };
}

export function bubblesClear() {
  return {
    type: ACTION_TYPES.BUBBLE_CHAT_CLEAR,
  };
}

export function setCurrentActiveTab(tab, groupId) {
  return {
    type: ACTION_TYPES.SET_ACTIVE_TAB,
    payload: { groupId, tab },
  };
}

export function setActiveClinicTab(clinicId) {
  return {
    type: ACTION_TYPES.SET_ACTIVE_CLINIC_TAB,
    payload: { clinicId },
  };
}

export function bubblesToMinimum(id) {
  return {
    type: ACTION_TYPES.BUBBLE_CHAT_TO_MINIMUM,
    payload: { id },
  };
}

export function minimumToBubble(id) {
  return {
    type: ACTION_TYPES.MINIMUM_CHAT_TO_BUBBLE,
    payload: { id },
  };
}

export function minimumBubbleFocused(id) {
  return {
    type: ACTION_TYPES.MINIMUM_CHAT_FOCUSED,
    payload: { id },
  };
}

export function minimumBubbleFocusOut(id) {
  return {
    type: ACTION_TYPES.MINIMUM_CHAT_FOCUS_OUT,
    payload: { id },
  };
}

export function setUploadGroup(id) {
  return {
    type: ACTION_TYPES.MINIMUM_UPLOAD_GROUP,
    payload: { id },
  };
}

export function loadBubblesFromStorage() {
  const dataFromStorage = localStorage.getItem('manadr.bubbles')
    ? JSON.parse(localStorage.getItem('manadr.bubbles'))
    : [];
  localStorage.setItem('manadr.bubbles', JSON.stringify(dataFromStorage));
  return {
    type: ACTION_TYPES.BUBBLE_CHAT_LOAD,
    payload: { bubbles: dataFromStorage },
  };
}
